import { createApp, h, useAttrs } from 'vue'
import { createPinia } from 'pinia'
import { defineCustomElement } from 'vue'
import tradeInWidget from './components/tradein-widget.ce.vue'
import TradeinButton from './components/tradein-widget-button.ce.vue'
import indexCss from './index.css?inline'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faChevronUp,
  faPencil,
  faArrowRight,
  faArrowLeft,
  faCircleExclamation
} from '@fortawesome/free-solid-svg-icons'
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { useTradeInStore } from './tradeInStore'

import router from './router'

const app = createApp({})
library.add(faChevronUp, faPencil, faCircleCheck, faArrowRight, faArrowLeft, faCircleExclamation)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.component('FontAwesomeIcon', FontAwesomeIcon)

const tradeInStore = useTradeInStore()
const TradeInWidgetElement = defineCustomElement({
  setup() {
    const attrs = useAttrs()

    const clientId = attrs.clientId

    const apiEndpoint = `https://tradein.cloud.audaris.icu/-/api`

    async function initialFetch() {
      tradeInStore.setAttributesFromProps(attrs)

      if (!clientId) return
      const url = new URL(apiEndpoint)
      url.searchParams.set('clientId', clientId)
      try {
        const response = await fetch(url)
        if (!response.ok) {
          const error = new Error(`Error ${response.status}`)
          error.statusCode = response.status
          error.url = url.href // add the URL to the error object
          throw error
        }
        const data = await response.json()
        const settings = data.settings
        const colors = settings.colors

        document.documentElement.style.setProperty('--color-brand', colors.brand)
        document.documentElement.style.setProperty('--color-brand-darker', colors['brand-darker'])
      } catch (error) {
        tradeInStore.error = true
        tradeInStore.errorMessage =
          'Das Ankauf-Tool ist nicht aktiviert, bitte wende dich an den Website-Betreiber'
        console.error(error)
      }
    }
    initialFetch()
  },
  render() {
    return h(tradeInWidget)
  },
  mounted() {
    const styleElement = document.createElement('style')
    const layoutElement = document.createElement('layout')
    styleElement.textContent = indexCss.toString()
    this.$el.appendChild(styleElement)
    this.$el.appendChild(layoutElement)
  }
})

customElements.define('audaris-tradein-form', TradeInWidgetElement)

const TradeInWidgetButtonElement = defineCustomElement(TradeinButton)

const originalConnectedCallback = TradeInWidgetButtonElement.prototype.connectedCallback
TradeInWidgetButtonElement.prototype.connectedCallback = function () {
  // Capture the text content before Vue processes it
  const textContent = this.textContent?.trim() || ''

  // Store it as an attribute so Vue can access it
  if (textContent) {
    this.setAttribute('slot-content', textContent)
  }

  // Call the original connectedCallback
  if (originalConnectedCallback) {
    originalConnectedCallback.call(this)
  }

  // Set up the API call and styling
  const attrs = this.attributes
  const clientId = this.getAttribute('client-id')
  const apiEndpoint = `https://tradein.cloud.audaris.icu/-/api`

  async function initialFetch() {
    const attrsObj = {}
    for (let i = 0; i < attrs.length; i++) {
      const attr = attrs[i]
      attrsObj[attr.name.replace(/-([a-z])/g, (g) => g[1].toUpperCase())] = attr.value
    }
    tradeInStore.setAttributesFromProps(attrsObj)

    if (!clientId) return
    const url = new URL(apiEndpoint)
    url.searchParams.set('clientId', clientId)
    try {
      const response = await fetch(url)
      if (!response.ok) {
        const error = new Error(`Error ${response.status}`)
        error.statusCode = response.status
        error.url = url.href
        throw error
      }
      const data = await response.json()
      const settings = data.settings
      const colors = settings.colors

      document.documentElement.style.setProperty('--color-brand', colors.brand)
      document.documentElement.style.setProperty('--color-brand-darker', colors['brand-darker'])
    } catch (error) {
      tradeInStore.error = true
      tradeInStore.errorMessage =
        'Das Ankauf-Tool ist nicht aktiviert, bitte wende dich an den Website-Betreiber'
      console.error(error)
    }
  }
  initialFetch()

  // Add styles
  const styleElement = document.createElement('style')
  styleElement.textContent = indexCss.toString()
  this.shadowRoot.appendChild(styleElement)
}

customElements.define('audaris-tradein-button', TradeInWidgetButtonElement)
